export function redirectToGDLogin() {
  const apiBaseUrl = process.env.EXPO_PUBLIC_API_BASE_URL
  const redirectTo = encodeURIComponent(window.location.origin)
  window.location.href = `${apiBaseUrl}/login?redirect_to=${redirectTo}`
}
